<template>
  <div class="account-item">
    <van-cell>
      <template #title>
        <span class="title">{{ safetypeName }}</span>
      </template>
      
      <template #label>
        <van-row class="asset-data-info">
            <van-col :span="12">
                <span>{{ $t('assets.usenum') }}</span>
                <p>{{  safeuseNum }}</p>
            </van-col>
            
            <van-col :span="12" class="txt-right" v-if="safeconversion">
                <span>{{ $t('assets.convert') }}($)</span>
                <p>{{  safeconversion }}</p>
            </van-col>
        </van-row>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: 'AccountInfo',
  props: ["typeName", "useNum", "conversion"],
  computed: {
    safetypeName() {
        return this.typeName || ''
    },
    safeuseNum() {
        return this.useNum || ''
    },
    safeconversion() {
        return this.conversion || ''
    },

  },
}
</script>

<style>

</style>
